import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiLogoutB2BEmailLoginMethod,
    type OpenApiLogoutB2BEmailLoginRequest,
    type OpenApiLogoutB2BEmailLoginResponseSuccess,
    OpenApiLogoutB2BEmailLoginUrl,
    OpenApiStartB2BEmailLoginMethod,
    type OpenApiStartB2BEmailLoginRequest,
    type OpenApiStartB2BEmailLoginResponseSuccess,
    OpenApiStartB2BEmailLoginUrl,
} from '#shared/api/schema';

const api = createApi({
    name: 'features/EmailAuth/api/emailAuthApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            startEmailLogin: builder.mutation<
                OpenApiStartB2BEmailLoginResponseSuccess,
                OpenApiStartB2BEmailLoginRequest
            >({
                query: (body) => {
                    return {
                        url: OpenApiStartB2BEmailLoginUrl,
                        method: OpenApiStartB2BEmailLoginMethod,
                        body,
                    };
                },
            }),
            logoutEmail: builder.mutation<OpenApiLogoutB2BEmailLoginResponseSuccess, OpenApiLogoutB2BEmailLoginRequest>(
                {
                    query: () => {
                        return {
                            url: OpenApiLogoutB2BEmailLoginUrl,
                            method: OpenApiLogoutB2BEmailLoginMethod,
                        };
                    },
                }
            ),
        };
    },
});

export const startEmailLogin = async (email: string): Promise<void> => {
    await api.endpoints.startEmailLogin.mutate({ email });
};

export const logoutEmail = async (): Promise<void> => {
    await api.endpoints.logoutEmail.mutate();
};
